const  Buttons = () => {
  return (
    <div>
        <>
        <div>
            <ul>
                <li><button className="border border-white py-2 px-6 rounded-full">login</button></li>
                <li><button className="btn-light bg-white py-2 px-2 rounded-full">Sign Up</button></li>
            </ul>
        </div>
        </>
    </div>
  )
}

export default Buttons
